var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTvColourBars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7483 10.4132L30.076 1M21.2517 10.4132L10.924 1",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9H41V38.4643H0V9Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15385 37.0271H6.30769V42.0576H3.15385V37.0271Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6923 37.0271H37.8462V42.0576H34.6923V37.0271Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.075 31.0576H37.925V34.0576H3.075V31.0576Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 34,
    width: 2,
    height: 2,
    fill: "#FF5C00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 34,
    width: 2,
    height: 2,
    fill: "#FFEA31"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12H8V29H3V12Z",
    fill: "#E2E2E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H13V29H8V12Z",
    fill: "#FFEA31"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12H18V29H13V12Z",
    fill: "#31F3FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12H23V29H18V12Z",
    fill: "#31FF45"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23 12H28V29H23V12Z",
    fill: "#FF31F7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12H33V29H28V12Z",
    fill: "#FF3131"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33 12H38V29H33V12Z",
    fill: "#000AFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8 29H13V32H8V29Z",
    fill: "#131313"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28 29H33V32H28V29Z",
    fill: "#131313"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18 29H23V32H18V29Z",
    fill: "#131313"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3 29H8V32H3V29Z",
    fill: "#000AFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23 29H28V32H23V29Z",
    fill: "#31F3FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13 29H18V32H13V29Z",
    fill: "#FF31F7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33 29H38V32H33V29Z",
    fill: "#E2E2E2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvColourBars);
export default __webpack_public_path__ + "static/media/tv-colour-bars.96d705c33ea60ac00ea5fe7e93cb8561.svg";
export { ForwardRef as ReactComponent };